function ClockIcon() {
  return (
    <svg
      width="19"
      height="20"
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.16986 1.20061C4.45569 0.968019 4.50204 0.543777 4.27337 0.253039C4.0447 -0.0376989 3.62761 -0.0848369 3.34177 0.147754L1.13247 1.9455C0.846633 2.17809 0.80029 2.60234 1.02896 2.89307C1.25763 3.18381 1.67472 3.23095 1.96055 2.99836L4.16986 1.20061Z"
        fill="#1C274C"
        className="fill"
      />
      <path
        d="M15.6582 0.147754C15.3724 -0.0848369 14.9553 -0.0376989 14.7266 0.253039C14.498 0.543777 14.5443 0.968019 14.8301 1.20061L17.0394 2.99836C17.3253 3.23095 17.7424 3.18381 17.971 2.89307C18.1997 2.60234 18.1534 2.17809 17.8675 1.9455L15.6582 0.147754Z"
        fill="#1C274C"
        className="fill"
      />
      <path
        d="M10.1628 6.74159C10.1628 6.36926 9.86605 6.06743 9.5 6.06743C9.13395 6.06743 8.83721 6.36926 8.83721 6.74159L8.83721 9.19143C8.83719 9.67127 8.83718 10.0794 8.87001 10.4181C8.90497 10.7789 8.98081 11.1134 9.16281 11.434C9.3448 11.7546 9.59164 11.9886 9.88137 12.1998C10.1533 12.3981 10.5008 12.6022 10.9094 12.8421L11.4646 13.1681C11.7817 13.3543 12.187 13.2438 12.37 12.9214C12.5531 12.5989 12.4444 12.1866 12.1274 12.0004L11.5989 11.6901C11.1564 11.4302 10.8662 11.2589 10.6536 11.1039C10.4528 10.9576 10.3656 10.8564 10.3108 10.7598C10.256 10.6633 10.2134 10.5359 10.1892 10.2858C10.1635 10.021 10.1628 9.67974 10.1628 9.16008L10.1628 6.74159Z"
        fill="#1C274C"
        className="fill"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.5 0.674181C4.25329 0.674181 0 5.00041 0 10.3371C0 15.6738 4.25329 20 9.5 20C14.7467 20 19 15.6738 19 10.3371C19 5.00041 14.7467 0.674181 9.5 0.674181ZM1.32558 10.3371C1.32558 5.74507 4.98539 2.02249 9.5 2.02249C14.0146 2.02249 17.6744 5.74507 17.6744 10.3371C17.6744 14.9291 14.0146 18.6517 9.5 18.6517C4.98539 18.6517 1.32558 14.9291 1.32558 10.3371Z"
        fill="#1C274C"
        className="fill"
      />
    </svg>
  );
}

export default ClockIcon;
